import type { TypedStartListening, TypedStopListening } from '@reduxjs/toolkit';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import type { AppDispatch } from '../create';
import type { IState } from '../state';

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening as TypedStartListening<
  IState,
  AppDispatch
>;

export const stopAppListening = listenerMiddleware.stopListening as TypedStopListening<
  IState,
  AppDispatch
>;
